'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require('react');

var React = _interopRequireWildcard(_react);

var _reactApollo = require('react-apollo');

var _reactSkeletor = require('@trainline/react-skeletor');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var __assign = undefined && undefined.__assign || function () {
    __assign = Object.assign || function (t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) {
                if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
            }
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

var QueryWithSkeleton = function QueryWithSkeleton(props) {
    return React.createElement(_reactApollo.Query, __assign({}, props), function (result) {
        var Children = function Children(childResult) {
            return React.createElement(React.Fragment, null, props.children(childResult));
        };
        if (!props.dummyData) {
            return React.createElement(Children, __assign({}, result));
        }
        var InSkeleton = (0, _reactSkeletor.createSkeletonProvider)(props.dummyData, function (_a) {
            var loading = _a.loading;
            return Boolean(loading);
        }, function () {
            return {
                color: 'transparent',
                background: 'linear-gradient(90deg, rgba(207, 216, 220, 0.2), rgba(207, 216, 220, 0.4), rgba(207, 216, 220, 0.2))'
            };
        })(Children);
        return React.createElement(InSkeleton, __assign({}, result));
    });
};
exports.default = QueryWithSkeleton;
//# sourceMappingURL=QueryWithSkeleton.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/web-makeup/dist/QueryWithSkeleton/QueryWithSkeleton.js
// module id = 1337
// module chunks = 0